import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
//import * as Sentry from '@sentry/angular';
import * as moment from 'moment';
import { Subject, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { DeviceInfoService } from './device-info.service';
import { GroupService } from './group.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private apiUrl = 'api';
  private logEntries: any[] = [];
  private maxEntries = 50; // Send log when this size is reached
  private originalConsoleLog: any;
  private originalConsoleError: any;
  private isSendingLogs = false;
  private logSubject = new Subject<void>();

  user: any;
  group: any;

  constructor(
    private http: HttpClient,
    @Optional() @Inject(REQUEST) private request: any,
    @Inject(PLATFORM_ID) private platformId: Object,
    private deviceInfo: DeviceInfoService,
    private userService: UserService,
    private groupService: GroupService
  ) {
    this.userService.userProfile$
      .subscribe(user => this.user = user);

    this.groupService.selectedGroup$
      .subscribe(group => this.group = group);

    //this.interceptConsoleLog();
    //this.setupLogSending();
  }

  public triggerLogSend(): void {
    if (this.logEntries.length > 0) {
      this.originalConsoleLog('Log sending called externally');
      this.logSubject.next();  // Trigger the log sending logic
    }
  }

  private setupLogSending() {
    this.logSubject.pipe(
      debounce(() => timer(1000)) // Adjust time as needed
    ).subscribe(() => {
      if (this.logEntries.length > 0 && !this.isSendingLogs) {
        this.sendLogs();
      }
    });
  }

  private interceptConsoleLog() {
    this.originalConsoleLog = console.log;
    this.originalConsoleError = console.error;

    console.log = (...args: any[]) => {
      this.originalConsoleLog.apply(console, args);
      this.captureLog(args);
    };

    console.error = (...args: any[]) => {
      this.originalConsoleError.apply(console, args);
      this.captureLog(args, true);
    };

    console.info = (...args: any[]) => {
      //this.originalConsoleLog.apply(console, args);
      this.captureLog(args, true);
    };
  }

  private captureLog(args: any[], isError: boolean = false) {
    const logEntry = {
      error: isError,
      log: args.map(arg => {
        if (arg instanceof Error) {
          return {
            message: arg.message,
            /*   stack: arg.stack */
          };
        }
        return arg;
      }),
      timestamp: moment().format('DD/MM/YYYY HH:mm:ss')
    };

    this.logEntries.push(logEntry);
    if (this.logEntries.length >= this.maxEntries) {
      this.logSubject.next();
    }

    if (isError) {
      const error = new Error(logEntry.log.map(log => log.message || log).join(' '));

      // Capture the error with Sentry
      //Sentry.captureException(error);

      // Rethrow the error
      //throw error;
    }
  }




  private sendLogs() {
    this.logEntries = [];
    this.logSubject.next();
    return;
    if (this.isSendingLogs) {
      return;
    }
    this.isSendingLogs = true;
    const apiUrl = `${this.apiUrl}/logger/dump`;
    this.http.post(apiUrl, { userId: this.user?.id, groupId: this.group?.id, browserInfo: this.deviceInfo.getBrowserInfo(), deviceInfo: this.deviceInfo.getDeviceInfo(), logs: this.logEntries }).subscribe({
      next: () => {
        this.originalConsoleLog('Logs sent to server');
        this.logEntries = []; // Reset the log array after sending
        this.isSendingLogs = false;
      },
      error: (err) => {
        this.originalConsoleLog('Failed to send logs', err);
        this.isSendingLogs = false;
      }
    });
  }
}
